import { useRef } from "react";
import { useAuth } from "@clerk/clerk-react";

/**
 * True after Clerk has finished its first load.
 * Later auth refreshes must not unmount the current screen.
 */
export function useClerkReady() {
  const { isLoaded, isSignedIn } = useAuth();
  const loadedOnceRef = useRef(false);
  if (isLoaded) loadedOnceRef.current = true;
  return {
    isLoaded,
    isSignedIn,
    clerkReady: isLoaded || loadedOnceRef.current,
  };
}
